"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var KeyNavigatorStoreMixin = require("app/util/browser/key-navigator").storeMixin;

var MultiActionStore = require("app/util/flux/multi-action-store");
var ActivityDraft = require("app/util/browser/activity-draft");
var URLUtil = require("app/util/browser/url");

function createStore(instanceKey) {
  var entitySuggestionsActions = EntitySuggestionsActions(instanceKey);
  var env = URLUtil.getPageEnv(window.location);
  var entityId = URLUtil.getEntityId(window.location.search);

  if (instanceKey === "activityInputNew") {
    var storedActivity = ActivityDraft.getActivity("entity");
    var entity = storedActivity.entity;
  } else {
    var entity = null;
  }

  var store = Reflux.createStore({
    mixins: [KeyNavigatorStoreMixin],
    state: {
      instanceKey: null,
      searchText: null,
      entity: entity,
      expandSuggestions: false,
      loading: true,
      adding: false,
      suggestions: [],
      selectedItem: entity,
      focusIndex: -1,
      focusId: -1,
      errorMsg: null,
      env: env,
      entityId: entityId,
      pagination: false,
      total: null,
      page: 0,
      emptyPage: false,
      createdEntity: null,
      selectable: true
    },
    init: function(){
      this.listenTo(entitySuggestionsActions.showSuggestions.started, this.onShowSuggestionsStarted);
      this.listenTo(entitySuggestionsActions.showSuggestions.completed, this.onShowSuggestionsCompleted);
      this.listenTo(entitySuggestionsActions.showSuggestions.failed, this.onShowSuggestionsFailed);
      this.listenTo(entitySuggestionsActions.hideSuggestions, this.onHideSuggestions);
      this.listenTo(entitySuggestionsActions.selectSuggestion, this.onSelectSuggestion);
      this.listenTo(entitySuggestionsActions.clearSelected, this.onClearSelected);
      this.listenTo(entitySuggestionsActions.focusItem, this.onFocusItem);
      this.listenTo(entitySuggestionsActions.keyNavigate, this.onKeyNavigate);

      this.listenTo(entitySuggestionsActions.addOrganization.started, this.onEntityAddStarted);
      this.listenTo(entitySuggestionsActions.addPerson.started, this.onEntityAddStarted);
      this.listenTo(entitySuggestionsActions.addDeal.started, this.onEntityAddStarted);

      this.listenTo(entitySuggestionsActions.addOrganization.completed, this.onEntityAddCompleted);
      this.listenTo(entitySuggestionsActions.addPerson.completed, this.onEntityAddCompleted);
      this.listenTo(entitySuggestionsActions.addDeal.completed, this.onEntityAddCompleted);

      this.listenTo(entitySuggestionsActions.addOrganization.failed, this.onError);
      this.listenTo(entitySuggestionsActions.addPerson.failed, this.onError);
      this.listenTo(entitySuggestionsActions.addDeal.failed, this.onError);
    },
    onShowSuggestionsStarted: function(text, page){
      if (!this.state.pagination || page === 0)
        this.state.suggestions = [];

      this.state.searchText = text;
      this.state.expandSuggestions = true;
      this.state.loading = true;
      this.state.page = page;
      this.trigger(this.state);
    },
    onShowSuggestionsCompleted: function(data, meta){
      if (meta.q !== this.state.searchText) {
        // This means that we're receiving a delayed response, since
        // the search text has changed. It would have been better if the
        // old request was cancelled, but for now we're just ignoring.
        return;
      }

      if (this.state.pagination && this.state.page > 0) {
        this.state.suggestions = this.state.suggestions.concat(data);
      } else {
        this.state.suggestions = data;
        this.state.total = meta.total;
      }

      this.state.loading = false;
      this.state.emptyPage = data.length === 0;
      this.trigger(this.state);
    },
    onShowSuggestionsFailed: function(data){
      this.state.loading = false;
      this.trigger(this.state);
    },
    onHideSuggestions: function(text){
      this.state.searchText = text || null;
      this.clearSuggestions();
      this.trigger(this.state);
    },
    onEntityAddStarted: function() {
      this.state.adding = true;
      this.trigger(this.state);
    },
    onSelectSuggestion: function (item) {
      if (!this.state.selectable)
        return;

      if (this.state.onSelect) {
        this.state.onSelect(item);
      } else {
        this.state.selectedItem = item;
        this.state.searchText = null;
        this.state.adding = false;
        this.state.createdEntity = null;
        this.clearSuggestions();
      }

      if (this.state.afterSelect) {
        this.state.afterSelect(item);
      }

      this.trigger(this.state);
    },
    onEntityAddCompleted: function(item) {
      this.showSuccessMessage(item.obj);
      this.state.createdEntity = item;
      this.trigger(this.state);
    },
    showSuccessMessage: function(object) {
      Signal.show({
        message: `${object} adicionada(o) com sucesso!`,
        type: "success"
      });
    },
    clearSuggestions: function(){
      this.state.expandSuggestions = false;
      this.state.suggestions = [];
      this.state.loading = true;
    },
    onClearSelected: function () {
      this.state.selectedItem = null;
      this.state.entity = null;
      this.state.searchText = null;
      this.clearSuggestions();

      if (this.state.afterClear) {
        this.state.afterClear();
      }

      this.trigger(this.state);
    },
    onFocusItem: function (index) {
      this.focusItem(this.state.suggestions, index);
      this.trigger(this.state);
    },
    onKeyNavigate: function (keyCode) {
      // The navigate method is defined in KeyNavigatorStoreMixin
      this.navigate(keyCode, this.state.suggestions);
    },
    enterPressed: function (element) {
      if(element && element.allowed !== false){
        this.onSelectSuggestion(element);
      }
    },
    escPressed: function () {
      this.state.searchText = null;
      this.onHideSuggestions();
    },
    onError: function(errorMsg) {
      this.state.errorMsg = errorMsg;
      this.state.adding = false;
      this.trigger(this.state);
      this.state.errorMsg = null;
    }
  });

  return store;
}

module.exports = MultiActionStore.factory(createStore);

var EntitySuggestionsActions = require("../actions/entity-suggestions-actions.js");



// WEBPACK FOOTER //
// ./app/shared/stores/entity-suggestions-store.js